import React, { useCallback, useEffect } from 'react';
import { Form, Space } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';
import CategoryCourseTreeSelect from 'Component/pages/components/coach/CategoryCourseTreeSelect';
import UdeskDatePicker from 'Component/common/udesk-date-picker';
import styled from 'styled-components';
import moment from 'moment';

const FilterWrapper = styled.div`
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
`;

interface FilterProps {
    onSubmit?: (values: any) => void;
}

export default React.memo(({ onSubmit }: FilterProps) => {
    const [form] = Form.useForm();
    const { ...courseTreeSelectProps } = CategoryCourseTreeSelect.useTreeSelect({ isAdmin: true });
    const onFinish = useCallback(
        (values) => {
            onSubmit?.({
                courseCategoryIds: values?.courseCategoryIds?.courses || [],
                startDate: values.date[0]?.split(' ')[0],
                startTime: values.date[0]?.split(' ')[0],
                endDate: values.date[1]?.split(' ')[0],
                endTime: values.date[1]?.split(' ')[0],
            });
        },
        [onSubmit]
    );

    const onReset = useCallback(() => {
        form.resetFields();
        form.submit();
    }, [form]);

    useEffect(() => {
        form.submit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FilterWrapper>
            <Form
                form={form}
                layout="inline"
                onFinish={onFinish}
                style={{
                    padding: '16px',
                    justifyContent: 'space-between',
                }}
                initialValues={{
                    date: [
                        moment().subtract(1, 'month').format('YYYY-MM-DD'),
                        moment().format('YYYY-MM-DD'),
                    ],
                }}
            >
                <Space>
                    <Form.Item name="courseCategoryIds" label="课程" style={{ width: 300 }}>
                        <CategoryCourseTreeSelect
                            {...courseTreeSelectProps}
                            placeholder="请选择"
                            multiple
                            treeCheckable
                            maxTagCount={1}
                        />
                    </Form.Item>

                    <Form.Item name="date">
                        <UdeskDatePicker allowClear={false} />
                    </Form.Item>
                </Space>

                <Form.Item>
                    <Space>
                        <button className="udesk-qa-ui-btn" onClick={onReset}>
                            {UdeskLocales['current'].labels.reset}
                        </button>
                        <button className="udesk-qa-ui-btn udesk-qa-ui-btn-primary" type="submit">
                            {UdeskLocales['current'].labels.confirm}
                        </button>
                    </Space>
                </Form.Item>
            </Form>
        </FilterWrapper>
    );
});
